export default "__VITE_ASSET__BmRx2IyQ__"